export default function () {
    return {
        KEYS: {
            COMPLETED: 'COMPLETED',
            FAILED: 'FAILED',
            CONVERTING: 'CONVERTING'
        }
    };
}



// WEBPACK FOOTER //
// ./src/app/enums/material/file/status/index.js